module.exports = __webpack_public_path__ + "img/pwa-install.2c88059f.svg";